var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeDropdown,
          expression: "closeDropdown",
        },
      ],
      class: _vm.classNames,
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closeDropdown.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { class: _vm.getCompositeClass }, [
        _c(
          "div",
          {
            staticClass: "Vlt-composite__prepend",
            class: { disabled: _vm.disabled || _vm.countrySelectDisabled },
            attrs: { tabindex: "0" },
            on: {
              click: _vm.toggleDropdown,
              keyup: function ($event) {
                $event.preventDefault()
                return _vm.keyboardNav.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "Vlt-dropdown__btn" }, [
              _c("div", {
                staticClass: "Nx-pi__flag",
                class: _vm.activeCountry.code.toLowerCase(),
              }),
              _c("span", { staticClass: "Nx-pi__btn__country_code" }, [
                _vm._v(_vm._s(_vm.activeCountry.callingCode)),
              ]),
            ]),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.open,
                    expression: "open",
                  },
                ],
                ref: "list",
                staticClass: "Vlt-dropdown__panel__content",
              },
              _vm._l(_vm.filteredCountries, function (pb, index) {
                return _c(
                  "li",
                  {
                    key: pb.code,
                    class: [
                      "Vlt-dropdown__link",
                      {
                        "Vlt-dropdown__link_selected": _vm.isActiveIndex(index),
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.choose(pb)
                      },
                      mousemove: function ($event) {
                        _vm.selectedIndex = index
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "Nx-pi__flag",
                      class: pb.code.toLowerCase(),
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "Vlt-dropdown__label",
                        attrs: { title: pb.name },
                      },
                      [
                        _c("p", { staticClass: "Nx-pi__list__country_name" }, [
                          _vm._v(_vm._s(pb.name)),
                        ]),
                      ]
                    ),
                    _c("span", { staticClass: "Nx-pi__list__country_code" }, [
                      _vm._v(_vm._s(pb.callingCode)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _c("div", { staticClass: "Vlt-input" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            ref: "phone",
            attrs: {
              "data-cy": "sms-registration-phone-number-input",
              maxlength: 25,
              placeholder: _vm.placeholder,
              disabled: _vm.disabled,
              type: "tel",
            },
            domProps: { value: _vm.phone },
            on: {
              blur: _vm.blur,
              focus: _vm.focus,
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.phone = $event.target.value
                },
                _vm.onInput,
              ],
              paste: _vm.onInput,
            },
          }),
          _c("label", { staticClass: "Vlt-label" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }